import {CurrencyResponseType, ICurrency} from "@/entity/currency/currency.types";

export default class Currency implements ICurrency {
    id: number;
    name: string;
    code: string;
    constructor(data: CurrencyResponseType) {
        this.id = data.id;
        this.name = data.name;
        this.code = data.code;
    }
}